import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { ALIGNED_IMAGE_WRAPPER } from '../constants';
import { AlignedImageWrapperElement } from '../types';

export const isAlignedImageWrapper = isElementType<AlignedImageWrapperElement>(ALIGNED_IMAGE_WRAPPER);
